import { Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { IconDirectDebit } from '../../components-deprecated'
import { getImageClassName } from '../../utils/getClassName'
import * as Styled from './styles'

export interface DirectDebitProps {
  isHorizontal?: boolean
  isInvalid: boolean
  issuer?: string
  label?: string
}

const DIRECT_DEBIT_HIDDEN_NUMBERS = '•••• •••• ••••'

export const DirectDebit = ({
  isHorizontal = false,
  isInvalid,
  label = '',
  issuer,
}: DirectDebitProps): ReactElement => {
  const labelText = label.length <= 4 ? `${DIRECT_DEBIT_HIDDEN_NUMBERS} ${label}` : label

  return (
    <Styled.DirectDebitWrapper isFaded={isInvalid} horizontal={isHorizontal}>
      <Styled.IssuerLogoWrapper className={getImageClassName()} horizontal={isHorizontal}>
        <IconDirectDebit height="28px" width="auto" />
      </Styled.IssuerLogoWrapper>
      <Text variant={isHorizontal ? 'bodyMD' : undefined}>{labelText}</Text>
      {isHorizontal && <Space size="s80" horizontal />}
      <Text>{issuer}</Text>
    </Styled.DirectDebitWrapper>
  )
}
